import logger from 'util/logger';
/* eslint-disable import/prefer-default-export, no-console */
export const parse = (string, fallback = {}) => {
  let result = fallback;
  if (string) {
    try {
      result = JSON.parse(string);
    } catch (e) {
      // CLEANUP: structured logging on server?
      // TODO: possible to add page URL?
      logger(`Error: JSON.parse(${string})`, 'error');
    }
  }
  return result;
};
